import React, { useState, useEffect } from "react";
import {
  makeStyles,
  createStyles,
  ButtonGroup,
  Button,
  TextField,
  Link
} from "@material-ui/core";
import { connect } from "react-redux";
import { IStoreState } from "../Store";
import { IEnvironment, ShareOptions, ShareStatus } from "../../interface/IShareInfo";
const ShareIcon = require("../../../../public/images/icons/share-icon.svg");

import { Text } from "../Ui/Text";
import { ButtonToggler } from "./ButtonToggler";
import { ITheme } from "../Layout/themes";
import {
  validateEmail
} from "../../commons/utils/validations";
import { openHowItWorksModal } from "../HowItWorksModal/actions";
import { submitSharing } from "../Pages/TicketSharing/actions";
import { ThunkDispatch } from "redux-thunk";
import { showLoading } from "../Ui/ConnectedFullscreenLoader/actions";
import { addToken } from "../../commons/utils/addToken";
import "./input.css";

import { StxInternationalPhoneField, StxInput } from "../../../stencil-wrapper";

const useStyles = makeStyles(({ palette, typography, breakpoints }: ITheme) => {
  return createStyles({
    root: {
      background: "#fff",
      border: "1px solid #ebebeb",
      borderRadius: 2,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center"
    },
    hidden: {
      display: "none"
    },
    header: {
      width: "100%",
      padding: 10,
      borderBottom: "1px solid #ebebeb",
      display: "flex",
      alignItems: "center"
    },
    shareIcon: {
      color: palette.text.secondary,
      width: "3.4em",
      height: "3.1em",
      fontSize: "1.2rem",
      marginRight: 5
    },
    shareInfoTextContainer: {
      width: "100%",
      textAlign: "center"
    },
    shareTicketHeadingText: {},
    shareTicketBodyText: {},
    linkText: {
      fontSize: 12,
      fontWeight: 600,
      [breakpoints.down("xs")]: {
        display: "block"
      }
    },
    controlsContainer: {
      width: "100%",
      padding: "20px 10px 10px 10px",
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "center",
      flexWrap: "wrap"
    },
    addPersonIcon: {
      fontSize: "2rem",
      color: palette.primary.main
    },
    formControl: {
      width: "100%",
      flexShrink: 1,
      maxWidth: "215px",
      minWidth: "100px",
    },
    userInput: {
      width: "100%",
      height: 40,
      fontSize: "16px"
    },
    buttonsContainer: {
      padding: "10px 10px 20px 10px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      borderTop: "1px solid #ebebeb"
    },
    cancelButton: {
      color: palette.primary.main,
      fontSize: "1rem",
      fontWeight: 600,
      textTransform: "none",
      minWidth: 177,
      height: 40,
      boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.1);",
      [breakpoints.down("sm")]: {
        minWidth: "48%"
      }
    },
    shareButton: {
      backgroundColor: palette.success.main,
      color: palette.success.contrastText,
      fontSize: "1rem",
      fontWeight: 600,
      textTransform: "none",
      minWidth: 177,
      height: 40,
      boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.1);",

      "&:hover": {
        backgroundColor: palette.success.dark
      },
      [breakpoints.down("sm")]: {
        minWidth: "48%"
      }
    },
    info: {
      maxWidth: "256px",
      maxHeight: "34px",
      fontSize: "12px",
      textAlign: "center",
      color: "#171717",
      marginBottom: "20px"
    }
  });
});

interface IProps {
  loading: boolean;
  env: IEnvironment,
  shareStatus: ShareStatus;
  openHowItWorksModal: () => void;
  submitSharing: ({
    shareOption,
    optionValue
  }: {
    shareOption: ShareOptions;
    optionValue: string;
  }) => void;
  showLoading: (loadingText?: string) => void;
}

export const SharePanelComponent = ({
  loading,
  shareStatus,
  env,
  openHowItWorksModal,
  submitSharing,
  showLoading
}: IProps) => {

  const [selectedShareOption, setSelectedShareOption] = useState(
    env.SHARE_OPTIONS[0].value
  );
  var stxInternational: any;
  var stxInput: any;
  // Hack to get the change event listening
  useEffect(() => {
    stxInput.addEventListener('input', handleChangeInput);
    stxInternational.addEventListener('change', handleChangeCustom);
    stxInternational.addEventListener('invalid', handleInvalidPhone);
    
    return () => {
      stxInput.removeEventListener('input', handleChangeInput);
      stxInternational.removeEventListener("change", handleChangeCustom);
      stxInternational.removeEventListener('invalid', handleInvalidPhone);
    };
  }, [stxInternational]); // ESLint will yell here, if `stxInternational` is missing
  const isInvalidShareStaus = [
    ShareStatus.Accepted,
    ShareStatus.Requested,
    ShareStatus.ErrorStatus
  ].includes(shareStatus);

  const classes = useStyles({});

  const [optionValue, setOptionValue] = useState("");
  const [fieldError, setFieldError] = useState(undefined);

  const handleInvalidPhone =() => {
    setFieldError("Invalid Phone");
  }

  const handleChangeCustom = (e: any) => {
    setFieldError(undefined);
    setOptionValue(e.target.value);
  }
  
  const handleChangeInput = (e: any) => {
    setFieldError(undefined);

    if (selectedShareOption === ShareOptions.sms) {
    } else {
      if (!validateEmail(e.target.value)) {
        setFieldError("Email address is not valid");
      }
      setOptionValue(e.target.value);
    }
  };

  const handleSubmit = () => {
    submitSharing({ shareOption: selectedShareOption, optionValue });
  };

  const handleToggleSelectedOption = (x: ShareOptions) => {
    const phone:any = document.querySelector("#phone"),
          email:any = document.querySelector("#email");
    phone.value = "";
    email.value = "";
    setSelectedShareOption(x);
    setFieldError(undefined);
    setOptionValue("");
  };

  const handleCancelShareTicket = () => {
    const index = location.search.indexOf("mobiUrl=");
    if (index > -1) {
      const url = location.search.slice(index + "mobiUrl=".length);
      showLoading("Loading your ticket...");
      window.location.href = addToken(url);
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <div className={classes.shareInfoTextContainer}>
          <Text className={classes.shareTicketHeadingText} variant="h5">
            Share ticket
          </Text>
          <Text className={classes.shareTicketBodyText} variant="caption">
            Securely share tickets with your friends.{" "}
            <Link
              component="a"
              href="#"
              id="hello123321"
              onClick={(e: any) => {
                e.preventDefault();
                openHowItWorksModal();
              }}
              variant="h5"
              className={classes.linkText}
              data-testid="howitwork-link"
            >
              How it works
            </Link>
          </Text>
        </div>
      </div>
      <div className={classes.controlsContainer}>
        <ButtonToggler
          handleToggle={handleToggleSelectedOption}
          options={env.SHARE_OPTIONS}
        />
        <StxInput
          disabled={selectedShareOption === ShareOptions.email ? false : true}
          type="email"
          id="email"
          ref={elem => stxInput = elem}
          help-text={fieldError}
          className={`${selectedShareOption === ShareOptions.email ? "" : classes.hidden} ${classes.formControl} stx-input`}
        ></StxInput>
        <StxInternationalPhoneField
          id="phone"
          name="phone"
          height="40px"
          help-text={fieldError}
          ref={elem => stxInternational = elem}
          disabled={selectedShareOption === ShareOptions.email ? true : false}
          preferred-countries={env.PREFERRED_COUNTRIES}
          className={`${selectedShareOption === ShareOptions.email ? classes.hidden : ""} ${classes.formControl} stx-input`}
        >
        </StxInternationalPhoneField>


      </div>
      <div className={classes.info}>
        By entering this information you agree that you have the receivers
        consent to do so
      </div>
      <div className={classes.buttonsContainer}>
        <Button
          variant="outlined"
          className={classes.cancelButton}
          color="default"
          onClick={handleCancelShareTicket}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          className={classes.shareButton}
          data-value={optionValue}
          disabled={Boolean(!optionValue || fieldError || isInvalidShareStaus)}
          onClick={handleSubmit}
        >
          Share ticket
        </Button>
      </div>
    </div>
  );
};

const mapStateToProps = (state: IStoreState) => ({
  loading: state.ticketShareData.loading,
  shareStatus:
    state.ticketShareData.data && state.ticketShareData.data.shareStatus
      ? state.ticketShareData.data.shareStatus
      : ShareStatus.ErrorStatus
    ,
  env: state.env,

});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => ({
  showLoading: (loadingText?: string) => dispatch(showLoading(loadingText)),
  openHowItWorksModal: () => dispatch(openHowItWorksModal()),
  submitSharing: ({
    shareOption,
    optionValue
  }: {
    shareOption: ShareOptions;
    optionValue: string;
  }) => dispatch(submitSharing({ shareOption, optionValue }))
});

export const SharePanel = connect(
  mapStateToProps,
  mapDispatchToProps
)(SharePanelComponent);
